// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__ANC8r","closeModalIcon":"PopUpModal_closeModalIcon__hlBit"};